// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1rhc9","title":"Header_title__gC4Ck","side":"Header_side__3Qo7z"};